import React from "react";
import { CellContext } from "@tanstack/react-table";
import { TransactionListItemDto } from "../../../common/types/transaction";
import { Button } from "../../general/Button/Button";
import styles from "./TransferMatchCell.module.scss";
import { useTransferMatchModal } from "./TransferMatchModalContext";

export const TransferMatchCell = ({
    row,
}: CellContext<TransactionListItemDto, any>) => {
    const { openTransferMatch } = useTransferMatchModal();
    const pairedTransferId = row.original.pairedTransferId;

    return (
        <Button
            variant={pairedTransferId ? "link" : "secondary"}
            className={styles.button}
            onClick={() => openTransferMatch(row.original)}
        >
            {pairedTransferId ? "Matched" : "Match"}
        </Button>
    );
};
